import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Box } from '../../components';
import { PageWithTabs } from '../../layouts';
import ContentManagementForm from '../../forms/contentManagement/ContentManagementForm';
import { Query } from 'react-apollo';
import GetEatery from '../../graphql/queries/GetEatery';

type Props = RouteComponentProps<MatchParams>;

type MatchParams = {
  step: string;
  id?: string;
};

const DINING_TABS = [
  { title: 'Details', to: (id?: string) => `/content-management/dining/${id ? id : 'create-new'}/details` },
];

const CreateEditDining: React.FC<Props> = (props) => {
  const { match, location } = props;
  // Check if we're in create mode by looking at the URL path
  const isEditing = !location.pathname.includes('create-new');

  console.log('CreateEditDining - Props:', {
    matchParams: match.params,
    path: location.pathname,
    isEditing,
  });

  return (
    <PageWithTabs
      tabs={DINING_TABS.map((tab) => ({
        ...tab,
        to: typeof tab.to === 'function' ? tab.to(match.params.id) : tab.to,
      }))}
      alignItems="inherit"
    >
      <Box flexDirection="row" p={4}>
        {isEditing ? (
          <Query query={GetEatery} variables={{ id: match.params.id }}>
            {({ loading, error, data }) => {
              console.log('CreateEditDining - Query Response:', { loading, error, data });
              return (
                <ContentManagementForm
                  initialValues={data.eatery || {}}
                  loading={loading}
                  isNewPost={false}
                  step="dining"
                  formType="edit"
                />
              );
            }}
          </Query>
        ) : (
          <ContentManagementForm initialValues={{}} loading={false} isNewPost={true} step="dining" formType="create" />
        )}
      </Box>
    </PageWithTabs>
  );
};

export default CreateEditDining;



// WEBPACK FOOTER //
// ./src/containers/contentManagement/CreateEditDining.tsx